/**
 * Modal displayed when subscription is partially fulfilled due to limited availability
 */

import { FC } from "react";
import { Modal, Text } from "@mantine/core";
import { LargeBtn, color } from "@funded-here-interface/common";
import { PARTIAL_SUBSCRIPTION_MESSAGES } from "./constants";

interface PartialSubscriptionModalProps {
  opened: boolean;
  onClose: () => void;
  requestedAmount: string;
  subscribedAmount: string;
  currency: "SGD" | "USD";
}

const PartialSubscriptionModal: FC<PartialSubscriptionModalProps> = ({
  opened,
  onClose,
  requestedAmount,
  subscribedAmount,
  currency,
}) => {
  return (
    <Modal
      centered
      size="sm"
      overlayProps={{
        blur: 3,
        opacity: 0.1,
      }}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
    >
      <div style={{ marginTop: 20, marginBottom: 5 }}>
        <Text
          style={{
            fontSize: "20px",
            fontWeight: 700,
            marginBottom: "16px",
          }}
        >
          {PARTIAL_SUBSCRIPTION_MESSAGES.TITLE}
        </Text>
        <Text
          style={{
            fontSize: "14px",
            marginBottom: "24px",
          }}
        >
          {PARTIAL_SUBSCRIPTION_MESSAGES.BODY_TEMPLATE(
            currency,
            requestedAmount,
            subscribedAmount
          )}
        </Text>
        <LargeBtn
          onClick={onClose}
          backgroundColor={color.FHGREEN}
          textColor="#FFFFFF"
          width="100%"
        >
          Okay
        </LargeBtn>
      </div>
    </Modal>
  );
};

export default PartialSubscriptionModal;
